import { render, staticRenderFns } from "./MealSkipping.vue?vue&type=template&id=30eeedef"
import script from "./MealSkipping.vue?vue&type=script&lang=js"
export * from "./MealSkipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports